<template>
    <AddStudentToGuardianForm />
  </template>
  
  <script setup>
  import AddStudentToGuardianForm from '@/components/features/guardians/AddStudentToGuardianForm.vue';
  </script>